import { AxiosResponse } from 'axios';
import { $http } from '@/plugins/axios';

export const leaderService = {
	fetchContact: (params: any, isAdmin = true): Promise<AxiosResponse> => {
		return $http.get(
			`/v1/${isAdmin ? 'org_admin' : 'accountant'}/contracts`,
			{
				params,
			}
		);
	},
	fetchDashboard: (params: any): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/dashboard_stats`, {
			params,
		});
	},
	fetchDashboardChart: (params: any): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/dashboard_stats_chart', {
			params,
		});
	},
	fetchDashboardOrg: (params: any, org_id?: any): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/org_dashboard/stats', {
			params: {
				...params,
				...(org_id ? { org_id } : {}),
			},
		});
	},

	fetchCredit: (params: any): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/credits', {
			params,
		});
	},

	featureFlags: (): Promise<AxiosResponse> => {
		return $http.get('v1/feature_flags/disabled');
	},

	listPackages: (): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/contract_packages');
	},
	listPackagesByStudent: (): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/invoices/add_seats_preview?seats=1');
	},
	buySeats: (data: any): Promise<AxiosResponse> => {
		return $http.post('v1/org_admin/invoices', data);
	},
	listVouchers: (): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/contract_vouchers');
		return $http.get('v1/org_admin/contract_vouchers');
	},
	getContractPayment: (
		data?: any,
		infoType?: 1 | 2
	): Promise<AxiosResponse> => {
		const suffix = infoType ? `/${infoType}` : '';
		return $http.get(`v1/org_admin/contract_payment_info${suffix}`, {
			params: data,
		});
	},
	createContractPayment: (data: any): Promise<AxiosResponse> => {
		return $http.post(`v1/org_admin/contracts`, data);
		return $http.post(`v1/org_admin/contracts`, data);
	},
	getContract: (id: string | number): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/contracts/${id}`);
	},
	listStudentsToClose: (): Promise<AxiosResponse> => {
		return $http.get('v1/org_admin/contracts/students_to_close');
	},
	closeContractStudents: (
		id: string | number,
		studentIds: Array<string | number>
	): Promise<AxiosResponse> => {
		return $http.put(`v1/org_admin/contracts/${id}/students_to_close`, {
			student_ids_to_close: studentIds,
		});
	},
	checkDiscountCode: (code: string, package_id: string | number): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/referral_code/check`, {
			params: {
				code, package_id
			},
		});
	},
	getBillingInfo: (): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/billing_info`);
	},
	getListQuota: (): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/media_quota_packages`);
	},
	createQuotaPayment: (data: any): Promise<AxiosResponse> => {
		return $http.post(`v1/org_admin/media_quota_packages`, data);
	},
	listCreditPackages: (): Promise<AxiosResponse> => {
		return $http.get(`v1/org_admin/credit_packages`);
	},
	createCreditPayment: (data: any): Promise<AxiosResponse> => {
		return $http.post(`v1/org_admin/credit_packages`, data);
	},
};
